import { SHOW_LOW_CALL_VOLUME_REMINDER, DISMISS_LOW_CALL_VOLUME_REMINDER } from './actionTypes/lowCallVolumeReminder';

export type LowCallVolumeDismissReason = 'user' | 'auto';

export const showLowCallVolumeReminder = (callCount: number, periodHours: number) => ({
    type: SHOW_LOW_CALL_VOLUME_REMINDER,
    payload: { callCount, periodHours }
});

export const dismissLowCallVolumeReminder = (reason: LowCallVolumeDismissReason = 'user') => ({
    type: DISMISS_LOW_CALL_VOLUME_REMINDER,
    payload: { reason }
});
